import { BaseWebComponentDataProviderFactory } from '../../../framework/BaseWebComponentDataProviderFactory';
import { API_TYPE_NIRVANA } from '../../../webcomponents.constants';
import { WebAccessControlCustomPagesFormBaseDataProvider } from '../dataProvider/WebAccessControlCustomPagesFormBaseDataProvider';

export class WebAccessControlCustomPagesFormFactory extends BaseWebComponentDataProviderFactory {
  constructor() {
    super();
    this.map.set(API_TYPE_NIRVANA, WebAccessControlCustomPagesFormBaseDataProvider);
  }
}
